import { type MetaFunction } from '@remix-run/node'
import rli from './rli.png'

export const meta: MetaFunction = () => [
	{ title: 'RLI' },
	{
		name: 'description',
		content: 'We offer insurance from RLI.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">RLI</h1>
			<img src={rli} alt="RLI" className="w-64" />
			<h3>Contact Information</h3>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Website:{' '}
				<a
					href="https://www.rlicorp.com/"
					target="_blank"
					rel="noopener noreferrer"
				>
					https://www.rlicorp.com/ (opens in a new tab)
				</a>
			</p>

			<section>
				<h3>Home Office Address</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					RLI
					<br />
					9025 N. Lindbergh Drive
					<br />
					Peoria, IL 61615
				</p>
			</section>
		</main>
	)
}
